export default function Marquee({ items, reverse = false, speed = "normal" }) {
  const speedClass =
    speed === "slow" ? "marquee-track-slow" : speed === "fast" ? "" : "";
  return (
    <div className="marquee overflow-hidden w-full" data-testid="marquee">
      <div
        className={`marquee-track ${
          reverse ? "marquee-track-reverse" : ""
        } ${speedClass}`}
      >
        {[...items, ...items].map((it, i) => (
          <span
            key={i}
            className="flex items-center gap-6 px-8 font-playfair text-3xl md:text-5xl lg:text-6xl text-white/90 whitespace-nowrap"
          >
            {it}
            <span className="text-[#D4AF37] text-2xl md:text-4xl">✦</span>
          </span>
        ))}
      </div>
    </div>
  );
}
